import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEclipsemosquittoComponent } from './simple-icons-eclipsemosquitto.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEclipsemosquittoComponent ],
    exports:      [ SimpleIconsEclipsemosquittoComponent ],
    bootstrap:    []
})
export class SimpleIconsEclipsemosquittoModule {}
